import { Repository } from "src/firebase/firestore/repository";
import { AICoachLevelVocabulary } from "./entities/ai-coach-level-vocabulary.entity";

class AICoachLevelVocabularyRepository extends Repository<AICoachLevelVocabulary> {
  constructor() {
    super("ai_coach_level_vocabularies");
  }

  async find(args: any): Promise<(AICoachLevelVocabulary & { id: string })[]> {
    return (await super.find(args)) as (AICoachLevelVocabulary & { id: string })[];
  }
}

export const aiCoachLevelVocabularyRepository = new AICoachLevelVocabularyRepository();
